import React from 'react'
import makeStyles from 'shared/makeStyles';
import startWork from '../startWork.png'
import { Container, Typography, Box } from '@mui/material'
import { useDispatch } from 'react-redux'

const useStyles = makeStyles((theme) => ({
  image: {
    margin: 'auto',
    display: 'block',
    width: '100%',
    maxWidth: '500px',
  },
}))

export default function Home() {
  const classes = useStyles()
  const dispatch = useDispatch()
  React.useEffect(() => {
    dispatch({ type: 'SET_PAGE_TITLE', payload: '' })
  }, [dispatch])

  return (
    <Container maxWidth={'xl'}>
      <Container maxWidth={'xl'}>
        <Typography variant="h2" align="center">
          Halo!
        </Typography>
        <Box sx={{
          m: 1
        }} />
        <Typography variant="h6" align="center">
          Temukan apa yang kamu perlukan di menu di kiri
        </Typography>
      </Container>
      <Box sx={{
        mt: 5
      }}>
        <img src={String(startWork)} className={classes.image} alt="Mulai bekerja" />
      </Box>
    </Container>
  );
}
